var React = require('react');

function Mastercard (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;}\n\t.st1{fill:#FF5F00;}\n\t.st2{fill:#EB001B;}\n\t.st3{fill:#F79E1B;}\n"),React.createElement("g",{"key":1},[React.createElement("rect",{"y":"0","className":"st0","width":"152.4","height":"108","key":0}),React.createElement("g",{"key":1},[React.createElement("rect",{"x":"60.4","y":"25.7","className":"st1","width":"31.5","height":"56.6","key":0}),React.createElement("path",{"className":"st2","d":"M62.4,54c0-11,5.1-21.5,13.7-28.3c-15.6-12.3-38.3-9.6-50.6,6.1C13.3,47.4,16,70,31.7,82.3\n\t\t\tc13.1,10.3,31.4,10.3,44.5,0C67.5,75.5,62.4,65,62.4,54z","key":1}),React.createElement("path",{"className":"st3","d":"M134.4,54c0,19.9-16.1,36-36,36c-8.1,0-15.9-2.7-22.2-7.7c15.6-12.3,18.3-34.9,6-50.6c-1.8-2.2-3.8-4.3-6-6\n\t\t\tc15.6-12.3,38.3-9.6,50.5,6.1C131.7,38.1,134.4,45.9,134.4,54z","key":2})])])]);
}

Mastercard.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 152.4 108","style":{"enableBackground":"new 0 0 152.4 108"},"xmlSpace":"preserve"};

module.exports = Mastercard;

Mastercard.default = Mastercard;



// WEBPACK FOOTER //
// ./src/images/icons/mastercard.svg